import { Injectable, EventEmitter } from '@angular/core';
import { globalData } from 'src/app/main/Models/global.model';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  origData: Array<any> = [];
  public showedData: Array<any> = [];

  filters: any = {};


  constructor(data: Array<any>) 
  { 
    this.setData(data);
  	this.reinitFilters();
  }

  setData(data: Array<any>)
  {
  	this.origData = data;
    this.showedData = data;
  }

  orderBy(prop, desc=false, subObject:string=null)
  {
    let sens = desc ? -1 : 1;

    this.showedData = this.origData.sort((d1, d2) => {
      if(subObject) 
      	return d1[subObject][prop]>d2[subObject][prop] ? sens : -sens;
      return d1[prop]>d2[prop] ? sens : -sens;
    });
  }




  getFilterProperty(prop, subObject:string=null)
  {
    let propList:any[] = [];

    this.showedData.forEach((item)=> {

      if(subObject) item = item[subObject];

      if(item != undefined && item[prop]!=undefined
      && propList.some((el,i,propList)=>{return el==item[prop]}) === false ) {
        propList.push(item[prop]);
      }
    })

    return propList.sort();
  }


  filterBy(prop, value, subObject:string=null)
  {
    if(value==null && this.filters[prop]!=undefined) delete this.filters[prop]
    else this.filters[prop] = {value: value, subObject: subObject};

    /* SPECIAL POUR DATES : A VOIR
    else {
      if(prop=='dateStart' || prop=='dateEnd') {
         let valueAsDate = new Date(value.target.valueAsDate);
         this.filters[prop] = {value: valueAsDate, subObject: subObject};
      } else {
        this.filters[prop] = {value: value, subObject: subObject};
      }
    }
    */

    this.showedData = this.origData;

    for(let filterProp in this.filters) {
    	
    	let filterValue = this.filters[filterProp].value;
    	let filterSubObject = this.filters[filterProp].subObject;

    	this.showedData = this.showedData.filter((dataElement)=>{
    		let item = filterSubObject ? dataElement[filterSubObject]
    								   : dataElement;

        if(Array.isArray(filterValue)) return filterValue.includes(item[filterProp]);              
    		return item[filterProp] == filterValue;
    	});
    }

    ////this.filterBySelectedBuildingsIfNecessary();

/*
    this.origData.forEach((item)=>{
      let push = true;

      for(let prop in this.filters) {

        if(this.filters[prop].subObject!='') item = item[subObject];

        if(this.filters[prop].value != null) {
          if(prop=='dateStart') {
            let curDate = new Date(item.date);
            if(curDate < this.filters[prop].value ) push = false;
          } else if(prop=='dateEnd') {
            let curDate = new Date(item.date);
            if(curDate > this.filters[prop].value) push = false;
          } else {
            if(item[prop] != this.filters[prop].value) push = false;
          }
        }
      }
      
      if(push) this.showedData.push(this.origData[i]);
      
    });
*/
  }

  reinitFilters()
  {
    this.filters = {};
    this.showedData = this.origData;
  }
}
